/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateQuestionTypesControllerUpdateMutationRequest, TemplateQuestionTypesControllerUpdateMutationResponse, TemplateQuestionTypesControllerUpdatePathParams, TemplateQuestionTypesControllerUpdate400, TemplateQuestionTypesControllerUpdate401, TemplateQuestionTypesControllerUpdate403, TemplateQuestionTypesControllerUpdate404 } from "../../models/checklistsController/TemplateQuestionTypesControllerUpdate";

function getTemplateQuestionTypesControllerUpdateUrl(id: TemplateQuestionTypesControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/checklist-template-question-types/${id}` as const }  
  return res
}

/**
 * @summary Update a checklist template question type
 * {@link /api/v1/checklist-template-question-types/:id}
 */
export async function templateQuestionTypesControllerUpdate(id: TemplateQuestionTypesControllerUpdatePathParams["id"], data?: TemplateQuestionTypesControllerUpdateMutationRequest, config: Partial<RequestConfig<TemplateQuestionTypesControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TemplateQuestionTypesControllerUpdateMutationResponse, ResponseErrorConfig<TemplateQuestionTypesControllerUpdate400 | TemplateQuestionTypesControllerUpdate401 | TemplateQuestionTypesControllerUpdate403 | TemplateQuestionTypesControllerUpdate404>, TemplateQuestionTypesControllerUpdateMutationRequest>({ method : "PATCH", url : getTemplateQuestionTypesControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}